import { Component, OnInit } from '@angular/core';
import {environment} from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.scss'],
})
export class LicenseComponent  implements OnInit {

  license;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.getLicense()
  }

  getLicense(){
    let headers={
      intezmeny: "203508"
    }
    this.http
      .get(
        '/api/license',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.license = response[0]

        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }

  protected readonly environment = environment;
}
